import { AdminApi } from 'stylemix-vue-admin'

export default class PriceZonesApi extends AdminApi {
  constructor(vehicleId, parameters) {
    super(`vehicles/${vehicleId}/zone-to-zone-prices`, parameters)
  }
}
